<template>
  <section class="store-item van-hairline--surround" @click.stop="processToOrderDetail(store)">
    <div class="flex webkit-box space-between align-center store-item-header">
      <h4 class="flex webkit-box align-center flex-1 van-ellipsis">
        <p class="van-ellipsis store-item-title">{{ store.providerName || store.supplierName || '合作供应商' }}</p>
        <div v-if="isPickOrder" class="store-item-split-tag">
          <span>自提</span>
        </div>
        <div v-else class="store-item-split-tag">
          <span>快递</span>
        </div>
      </h4>
      <div v-if="isShowStatus" :class="renderClassByStatus(store.status)" class="store-item-status">
        {{ store.status | cargoStatus(store) }}
      </div>
    </div>

    <!-- 商品列表slot -->
    <slot />
  </section>
</template>

<script>
import { orderStatusEnum } from '@/constant';

export default {
  props: {
    store: {
      type: Object,
      default: () => {}
    },
    isSplitOrder: {
      // 是否拆单
      type: Boolean,
      default: false
    },
    isPickOrder: {
      // 是否自提
      type: Boolean,
      default: false
    },
    // shouldPay: {
    //   // 未支付？
    //   type: Boolean,
    //   default: false
    // },
    // isLink: {
    //   // 可以点击跳转？
    //   type: Boolean,
    //   default: true
    // },
    isShowStatus: {
      type: Boolean,
      default: true
    },
    isCustomPageTo: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    processToOrderDetail(store) {
      if (store.isRefund) {
        this.$router.push('/refund/' + store.refundId);
        return;
      }
      if (this.isCustomPageTo) {
        this.$emit('customPageTo', this.store);
        return;
      }
      const toFatherOrderDetailStatusArr = [
        orderStatusEnum.unpayed,
        orderStatusEnum.canceled,
        orderStatusEnum.expired,
        orderStatusEnum.unaudit
      ];

      // debugger;
      let orderId = '';
      if (toFatherOrderDetailStatusArr.includes(store.status) && this.isSplitOrder) {
        orderId = store.orderParentId;
      } else {
        orderId = store.orderId;
      }
      this.$router.push({
        name: 'orderDetail',
        params: {
          id: orderId
        }
      });
      // this.jumpToMallOrderDetail(orderId);
    },
    renderClassByStatus(status) {
      const goryArr = [
        orderStatusEnum.canceled,
        orderStatusEnum.expired,
        orderStatusEnum.finished,
        orderStatusEnum.refunded
      ];
      if (goryArr.includes(status)) return 'gory';
      return 'yellow';
    }
  }
};
</script>

<style lang="less" scoped>
.store-item {
  padding: 12px 12px 16px;
  color: #262626;
  border-radius: 4px;
  font-size: 12px;
  &.van-hairline--surround::after {
    border-radius: 8px;
  }
  &-header {
    margin-bottom: 20px;
  }
  &-go {
    color: #bfbfbf;
    display: block;
    line-height: 1;
  }
  &-title {
    font-size: 14px;
    font-weight: 400;
  }
  h4 {
    line-height: 1;
    p {
      max-height: 100%;
    }
  }
  &-split-tag {
    border-radius: 2.5px;
    font-size: 12px;
    background: #ebf8ff;
    color: #1e8dff;
    width: 30px;
    height: 17.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.8);
    margin-left: 4px;
  }
  &-status {
    min-width: 48px;
    text-align: right;
    color: #bfbfbf;
    &.gory {
      color: #bfbfbf;
    }
    &.yellow {
      color: #ff8200;
    }
  }
}
</style>
